module.exports = __webpack_public_path__ + "img/jbt9162_19_1999.prt.6349fb98.jpg";